<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal")
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ $t('attach_invoices') }}

        v-card-text.pa-0
          v-container.white(style="max-width:600px")
            v-layout.mt-2
              v-text-field(v-model="searchText" placeholder='Search invoice' hide-details dense outlined height="40" background-color="basic200")
                template(v-slot:append)
                  eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
          
          v-container.px-1(style="max-width:600px")
            v-layout.my-6(v-if="isFetching")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            .contain-layout(v-else)
              v-layout.my-6(v-if="invoices.length == 0")
                v-row.fill-height.ma-0(align='center' justify='center')
                  div.mx-auto
                    v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                    p.caption {{ $t('invoice_not_found') }}
              div(v-else)
                template(v-for="(invoice, index) in invoices")
                  v-card(flat @click="clickInvoice(invoice, index)")
                    v-row.align-center.ma-0.px-4.py-1(
                      style="background-color: var(--v-basic600T08)",
                      v-if="isFirstDate(index)"
                    )
                      v-col.ma-0.pa-0
                        .s2.primary400--text {{ getMonth(invoice.record_date) }}
                    v-row.align-center.ma-0.px-4.py-3.border-bottom 
                      v-col.ma-0.pa-0
                        .s1.basic800--text {{ invoice.name }}
                        .c1.basic600--text.d-inline-flex
                          | {{ '#' + invoice.rid }}
                          span.mx-1(style="font-size: 3px") ●
                          | {{ getShortDate(invoice.record_date) }}
                          span.mx-1(style="font-size: 3px") ●
                          .text-capitalize {{ invoice.category.name ? invoice.category.name : 'Other' }}
                      v-col.ma-0.pa-0.text-end
                        .s1(
                          :class="getStatus(invoice) == 'overdue' ? 'danger500--text' : ''"
                        ) {{ invoice.amount | displayPrice }}
                        .c1.danger500--text.text-capitalize(
                          v-if="getStatus(invoice) == 'overdue'"
                        ) {{ getStatus(invoice) }}
                        .c1.success500--text.text-capitalize(
                          v-if="getStatus(invoice) == 'settled'"
                        ) {{ getStatus(invoice) }}
                        .c1.primary400--text.text-capitalize(
                          v-if="getStatus(invoice) == 'unsent'"
                        ) {{ getStatus(invoice) }}
                      v-col.py-0.pr-0.shrink
                        y-checkbox.ma-0.pa-0(v-model="invoice.selected" readonly style="margin-right: -8px !important;")
                  //- v-divider.basic300
                
                  //- template(v-for="(product, index) in products")
                    v-list-item.pl-1.pr-3(:key="product.id" :class="product.selected? 'blue lighten-5' : ''" @click="clickProduct(product, index)")
                      v-card.elevation-0.ma-2(style="border-radius: 2px")
                        v-img(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" height="70px" width="70px")
                      v-list-item-content
                        div {{ product.name }}
                        div.caption.text--secondary.mr-4(style="line-height: 1.2em;  min-height:14px;") {{ (product.description && product.description.length > 25) ? (product.description.substr(0,25) + '...') : product.description }}
                      v-list-item-action
                        y-checkbox(v-model="product.selected" readonly)
                    v-divider
              div.ma-4
                y-pagination(v-model="page" :pageSize="fetchCount" :count="count")

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32  @click="clickDone" :loading="isLoading" dark)
            .button-AA-small.basic100--text {{ $t('done') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ShowMoreText from '@/components/ShowMoreText'

export default {
  name: 'AttachInvoices',
  props: ['open', 'initialInvoices'],
  components: { ShowMoreText },
  data: () => ({
    isFetching: false,
    fetchCount: 20,
    page: 1,
    // totalPage: 1,
    count: 0,
    invoices: [],
    category: [],
    selectedInvoices: [],
    searchText: '',
    searchCountDown: null,
    isLoading: false,
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    page (val) {
      if (!this.isFetching) {
        this.fetchInvoices(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  mounted () {
    this.fetchInvoices(1)
    this.selectedInvoices = [...this.initialInvoices]
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    isFirstDate(index){
      var indexBefore = index - 1
      if (indexBefore < 0) {
        return true
      }else{
        var month = this.invoices[index].record_date.toString().split('-')[1]
        var monthBefore = this.invoices[indexBefore].record_date.toString().split('-')[1]
        if (month == monthBefore) {
          return false
        }else{
          return true
        }
      }
    },
    getMonth(val) {
      var dateArray = val.toString().split("-");
      var month = this.months[dateArray[1] - 1];
      var year = dateArray[0];
      return month + " " + year;
    },
    getShortDate(val) {
      var dateArray = val.toString().split("-");
      var date = dateArray[2];
      var month = this.months[dateArray[1] - 1].substring(0, 3);
      return date + " " + month;
    },
    getStatus(data) {
      const stat = data.payment_status
      const due = data.due_date
      const quotation = data.quotation
      if (stat == 'paid') {
        return "settled";
      } else if (quotation){
        return "quotation";
      } else {
        if(due){
          var currentDate = new Date();
          var duedate = due.split("-");
          var newDueDate = duedate[1] + "/" + duedate[2] + "/" + duedate[0];
          newDueDate = new Date(newDueDate);
          var daydiff = (currentDate - newDueDate) / 1000 / 60 / 60 / 24;
          if (stat == "unpaid" && daydiff > 0.9) {
            return "overdue";
          } else {
            return "unsent";
          }
        } else {
          return "unsent";
        }
      }
    },
    clickInvoice (invoice, index) {
      this.invoices[index].selected = !this.invoices[index].selected
      this.updateInvoice(this.invoices[index])
    },
    updateInvoice (invoice) {
      if (invoice.selected) {
        this.addInvoice(invoice)
      } else {
        this.removeInvoice(invoice)
      }
    },
    addInvoice (invoice) {
      this.selectedInvoices.push(invoice.item)
    },
    removeInvoice (invoice) {
      this.selectedInvoices = this.selectedInvoices.filter((x) => x.id !== invoice.id)
    },
    getSelected (invoice) {
      let selprod = this.selectedInvoices.filter(f => f.id === invoice.id)
      if (selprod.length > 0) {
        return true
      }
      return false
    },
    fetchInvoices(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let fetchUrl = `/books/${this.company.slug}/incomes/?page=${page}&expand=category&paid=false&quotation=false`
      if (this.searchText) {
        fetchUrl += `&search=${this.searchText}`
      }
      this.$axios.get(fetchUrl)
      .then((response) => {
        this.isFetching = false
        this.invoices = response.data.results.map(m => { return { item: m, id: m.id, rid: m.rid, name: m.name, description: m.notes, payment_status: m.payment_status, quantity: m.products.length, amount: m.amount, due_date: m.due_date, record_date: m.record_date, category: { ...m.category }, selected: this.getSelected(m) }})
        // this.invoices = [...response.data.results]
        this.count = response.data.count
        // const totalCount = response.data.count
        // if (totalCount % this.fetchCount == 0) {
        //   this.totalPage = totalCount/this.fetchCount
        // } else {
        //   this.totalPage = totalCount/this.fetchCount + 1
        // }
        // this.totalPage = parseInt(this.totalPage)
      })
      .catch(() => {})
    },
    searchItem () {
      let searchUrl = `/books/${this.company.slug}/incomes/?page=1&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id&expand=category&paid=false&quotation=false`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.invoices = response.data.results.map(m => { return { item: m, id: m.id, rid: m.rid, name: m.name, description: m.notes, quantity: m.products.length, amount: m.amount, due_date: m.due_date, record_date: m.record_date, category: { ...m.category }, selected: this.getSelected(m) }})
          this.count = response.data.count
          // const totalCount = response.data.count
          // if (totalCount % this.fetchCount == 0) {
          //   this.totalPage = totalCount/this.fetchCount
          // } else {
          //   this.totalPage = totalCount/this.fetchCount + 1
          // }
          // this.totalPage = parseInt(this.totalPage)
        })
        .catch(() => {})
    },
    clickDone () {
      this.showModal = false
      this.$emit('update:initialInvoices', this.selectedInvoices)
    }
  }
}
</script>

<style scoped>
.product-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; 
  overflow: hidden;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.todayDate {
  background-color: var(--v-info500);
  border-radius: 50%;
  color: white !important;
  width: 25px;
  margin: auto;
}
.todayDay {
  color: var(--v-info500) !important;
}
.todayList {
  background-color: var(--v-infoT16) !important;
}
.listItem {
  background-color: var(--v-basic600T08);
  border-radius: 4px;
}
</style>

<i18n>
{
  "en": {
    "invoice_not_found": "Invoice not found or empty"
  }
}
</i18n>
